import { type DeliveryByEvent, getDeliveryByEventName } from '@noths/polaris-client-utils';

import type { DeliveryEvent } from 'src/redux/delivery/types';

export const adaptProductDeliveryEventToStore = (
  deliveryByEvent: DeliveryByEvent,
): DeliveryEvent | null => {
  const deliveryEventObj = getDeliveryByEventName(deliveryByEvent.eventName);

  if (!deliveryEventObj) {
    return null;
  }

  return {
    date: deliveryByEvent.lastDeliveryBy,
    name: deliveryEventObj.name,
  };
};
